import Dialogs from "components/features/ActionCard/Dialogs";
import { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import ActionCardDialogsContext from "../features/ActionCard/Context";

const DialogsContextLayout = () => {
  const [isOpenEditActionDialog, setIsOpenEditActionDialog] = useState(false);
  const [isOpenDeleteActionDialog, setIsOpenDeleteActionDialog] = useState(false);
  const [isOpenAddActionDialog, setIsOpenAddActionDialog] = useState(false);
  const [isOpenViewActionDialog, setIsOpenViewActionDialog] = useState(false);
  const [isOpenCopyActionDialog, setIsOpenCopyActionDialog] = useState(false);
  const [isOpenAssigneeDialog, setIsOpenAssigneeDialog] = useState(false);
  const [isOpenImportActionDialog, setIsOpenImportActionDialog] = useState(false);
  const [isOpenPlanDetailDialog, setIsOpenPlanDetaiLDialog] = useState(false);
  const [isOpenCustomPlanCreateDialog, setIsOpenCustomPlanCreateDialog] = useState(false);
  const contextValue = useMemo(
    () => ({
      isOpenAddActionDialog,
      setIsOpenAddActionDialog,
      isOpenDeleteActionDialog,
      setIsOpenDeleteActionDialog,
      isOpenViewActionDialog,
      setIsOpenViewActionDialog,

      isOpenEditActionDialog,
      setIsOpenEditActionDialog,
      isOpenCopyActionDialog,
      setIsOpenCopyActionDialog,
      isOpenAssigneeDialog,
      setIsOpenAssigneeDialog,
      isOpenImportActionDialog,
      setIsOpenImportActionDialog,
      isOpenPlanDetailDialog,
      setIsOpenPlanDetaiLDialog,
      isOpenCustomPlanCreateDialog,
      setIsOpenCustomPlanCreateDialog
    }),
    [
      isOpenAddActionDialog,
      isOpenDeleteActionDialog,
      isOpenViewActionDialog,
      isOpenEditActionDialog,
      isOpenCopyActionDialog,
      isOpenAssigneeDialog,
      isOpenImportActionDialog,
      isOpenPlanDetailDialog,
      isOpenCustomPlanCreateDialog
    ]
  );

  return (
    <ActionCardDialogsContext.Provider value={contextValue}>
      <Outlet />
      <Dialogs />
    </ActionCardDialogsContext.Provider>
  );
};

export default DialogsContextLayout;
